import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class CaseAiReportReadyNotification extends Notification {
  icon() {
    return 'fas fa-robot';
  }

  href() {
    const data = this.attrs.notification.content() || {};
    return data.discussionId ? app.route('discussion', { id: data.discussionId }) : '#';
  }

  content() {
    const data = this.attrs.notification.content() || {};
    return 'AI 解读已生成：' + (data.title || '我的案例');
  }

  excerpt() {
    return '萨拉已为你的案例生成 AI 解读报告，点击查看';
  }
}
